import { dateUtils } from "components/helpers"
import { ColumnModel } from "components/library"

const dateStartTemplateBody = (rowData): string =>
  dateUtils.formatDateToLocale(rowData.fromDate)

const QuantityTierFixedRateRetroColumns: ColumnModel[] = [
  {
    field: "id",
    header: "ID",
    sortable: true,
  },
  {
    field: "fromDate",
    header: "Start Date",
    sortable: true,
    body: dateStartTemplateBody,
  },
  {
    field: "statusDescription",
    header: "Status",
    sortable: true,
  },
  {
    field: "currentRate",
    header: "Current Rate",
    sortable: true,
  },
]

export default QuantityTierFixedRateRetroColumns
